import { useEffect, useState } from "react";
import SuperAdminPageWrapper from "../components/SuperAdminPageWrapper";
import DesignSidebarTree from "./components/DesignSidebarTree";
import MarkdownView from "./components/MarkdownView";
import HtmlView from "./components/HtmlView";
import useDesignDocs from "./hooks/useDesignDocs";

const DesignDocsViewer = () => {
    const { tree, loadTree, getFileUrl, isLoading } = useDesignDocs();
    const [selected, setSelected] = useState(null);

    useEffect(() => { loadTree(); }, [loadTree]);

    // Resolve a signed URL for the clicked file, then render it by extension
    const handleSelect = async (node) => {
        const url = await getFileUrl(node.key);
        if (url) setSelected({ key: node.key, ext: node.ext, url });
    };

    return (
        <SuperAdminPageWrapper>
            <div className="container flex gap-4 items-start">
                <aside className="w-72 shrink-0 max-h-[80vh] overflow-auto bg-surface rounded-lg border border-border-light p-3">
                    <h2 className="text-sm font-semibold text-label mb-2 px-2">Design Docs</h2>
                    {isLoading && !tree.length
                        ? <p className="text-sm text-subtle px-2">Loading...</p>
                        : <DesignSidebarTree nodes={tree} selectedKey={selected?.key} onSelect={handleSelect} />}
                </aside>
                <main className="flex-1 min-w-0 bg-surface rounded-lg border border-border-light p-5">
                    {!selected && <p className="text-sm text-subtle">Select a document from the sidebar.</p>}
                    {selected?.ext === "md" && <MarkdownView url={selected.url} />}
                    {selected?.ext === "html" && <HtmlView url={selected.url} />}
                </main>
            </div>
        </SuperAdminPageWrapper>
    );
};

export default DesignDocsViewer;
